let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
  StatusBar,
  SectionList,
  Alert,
  Dimensions,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  Ionicons,
  FontAwesome5,
  MaterialCommunityIcons,
} from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width } = Dimensions.get('window');

const MyLearningHistoryScreen = () => {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // === Live API Data ===
  const [userId, setUserId] = React.useState('default');
  React.useEffect(() => {
    AsyncStorage.getItem('userToken').then(t => { if (t) setUserId(t.slice(0, 16)); }).catch(() => {});
  }, []);
  React.useEffect(() => {
    if (userId === 'default') return;
    const _ck = `professional_${_profUserId}_mylearninghistoryscreen`;
    apiFetch('/api/data/applications?sort=created_at&order=desc&limit=20').then(d => {
      if (d && !d.error) {
        const arr = Array.isArray(d) ? d : (d.data || d.results || []);
        AsyncStorage.setItem(_ck, JSON.stringify(arr)).catch(() => {});
      }
    }).catch(() => {});
  }, [userId]);

  const navigation = useNavigation();
  const [activeTab, setActiveTab] = useState('inProgress');
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    loadUserData();
  }, []);

  const loadUserData = async () => {
    try {
      const storedUser = await AsyncStorage.getItem(`professional_${_profUserId}_user`);
      const storedUserData = await AsyncStorage.getItem('userData');
      
      console.log('Loading user data from AsyncStorage...');
      
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        console.log('Found stored user:', parsedUser);
        setUserData(parsedUser);
      } else if (storedUserData) {
        const parsedUserData = JSON.parse(storedUserData);
        console.log('Found stored userData:', parsedUserData);
        setUserData(parsedUserData);
      } else {
        console.log('No user data found in AsyncStorage');
      }
    } catch (error) {
      console.error('Error loading user data:', error);
      // Set default user data if loading fails
      setUserData({ name: 'Student', full_name: 'Learning Student' });
    }
  };

  const getUserName = () => {
    if (!userData) return 'Student';
    return userData.full_name || userData.fullName || userData.name || 
           `${userData.first_name || userData.firstName || ''} ${userData.last_name || userData.lastName || ''}`.trim() || 
           'Student';
  };

  // Mixed color scheme for different courses
  const courseColors = {
    'Civil Engineering': '#f59e0b', // Orange
    'Mechanical Engineering': '#10b981', // Green
    'Electrical Engineering': '#3b82f6', // Blue
    'Software Engineering': '#8b5cf6', // Purple
    'Chemical Engineering': '#ef4444', // Red
    'Environmental Engineering': '#06b6d4', // Cyan
    'Biomedical Engineering': '#f97316', // Orange variant
    'Aerospace Engineering': '#14b8a6', // Teal
    'Materials Science': '#84cc16', // Lime
    'Data Science': '#6366f1', // Indigo
  };

  const getColorForCourse = (courseName) => {
    for (const [key, color] of Object.entries(courseColors)) {
      if (courseName.includes(key)) {
        return color;
      }
    }
    return '#f59e0b'; // Default orange
  };

  const inProgressCourses = [
    {
      id: '1',
      title: 'Civil Engineering Fundamentals',
      subtitle: 'Structural Analysis & Design',
      instructor: 'Dr. Sarah Johnson',
      progress: 65,
      totalLessons: 24,
      completedLessons: 16,
      nextLesson: 'Bridge Load Calculations',
      lastAccessed: '2 hours ago',
      estimatedTime: '3 hours remaining',
      category: 'Civil Engineering',
      difficulty: 'Intermediate',
      rating: 4.8,
    },
    {
      id: '2',
      title: 'AutoCAD for Engineers',
      subtitle: '2D & 3D Technical Drawing',
      instructor: 'Prof. Michael Chen',
      progress: 40,
      totalLessons: 18,
      completedLessons: 7,
      nextLesson: '3D Modeling Basics',
      lastAccessed: '1 day ago',
      estimatedTime: '8 hours remaining',
      category: 'Software Engineering',
      difficulty: 'Beginner',
      rating: 4.6,
    },
    {
      id: '3',
      title: 'Thermodynamics Principles',
      subtitle: 'Heat Transfer & Energy Systems',
      instructor: 'Dr. Emma Wilson',
      progress: 80,
      totalLessons: 20,
      completedLessons: 16,
      nextLesson: 'Entropy and Second Law',
      lastAccessed: '3 hours ago',
      estimatedTime: '2 hours remaining',
      category: 'Mechanical Engineering',
      difficulty: 'Advanced',
      rating: 4.9,
    },
    {
      id: '4',
      title: 'Circuit Analysis',
      subtitle: 'AC/DC Circuits & Components',
      instructor: 'Prof. David Kumar',
      progress: 25,
      totalLessons: 22,
      completedLessons: 5,
      nextLesson: 'Ohm\'s Law Applications',
      lastAccessed: '2 days ago',
      estimatedTime: '12 hours remaining',
      category: 'Electrical Engineering',
      difficulty: 'Intermediate',
      rating: 4.7,
    },
  ];

  const completedCourses = [
    {
      id: '5',
      title: 'Project Management Essentials',
      subtitle: 'Planning & Execution Strategies',
      instructor: 'Dr. Lisa Anderson',
      completedDate: '2024-12-15',
      duration: '16 hours',
      grade: 'A',
      rating: 4.8,
      certificate: true,
      category: 'Civil Engineering',
      skills: ['Project Planning', 'Risk Management', 'Team Leadership'],
    },
    {
      id: '6',
      title: 'Health & Safety Fundamentals',
      subtitle: 'Workplace Safety Standards',
      instructor: 'Prof. Robert Taylor',
      completedDate: '2024-12-10',
      duration: '12 hours',
      grade: 'A+',
      rating: 4.9,
      certificate: true,
      category: 'Environmental Engineering',
      skills: ['Safety Protocols', 'Risk Assessment', 'Compliance'],
    },
    {
      id: '7',
      title: 'Materials Science Basics',
      subtitle: 'Properties & Applications',
      instructor: 'Dr. Jennifer Lee',
      completedDate: '2024-11-28',
      duration: '20 hours',
      grade: 'B+',
      rating: 4.6,
      certificate: true,
      category: 'Materials Science',
      skills: ['Material Properties', 'Testing Methods', 'Selection Criteria'],
    },
    {
      id: '8',
      title: 'Python Programming',
      subtitle: 'Data Analysis & Automation',
      instructor: 'Prof. Alex Rodriguez',
      completedDate: '2024-11-20',
      duration: '24 hours',
      grade: 'A',
      rating: 4.7,
      certificate: true,
      category: 'Data Science',
      skills: ['Python', 'Data Analysis', 'Automation', 'Pandas'],
    },
  ];

  const learningStats = {
    inProgress: inProgressCourses.length,
    completed: completedCourses.length,
    totalHours: 156,
    averageProgress: Math.round(inProgressCourses.reduce((sum, course) => sum + course.progress, 0) / inProgressCourses.length),
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <FontAwesome5 key={i} name="star" size={12} color="#fbbf24" solid />
      );
    }

    if (hasHalfStar) {
      stars.push(
        <FontAwesome5 key="half" name="star-half-alt" size={12} color="#fbbf24" solid />
      );
    }

    const remainingStars = 5 - Math.ceil(rating);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <FontAwesome5 key={`empty-${i}`} name="star" size={12} color="#e5e7eb" />
      );
    }

    return stars;
  };

  const handleContinueLearning = (course) => {
    Alert.alert(
      'Continue Learning',
      `Resume "${course.title}" from "${course.nextLesson}"?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Continue',
          onPress: () => {
            navigation.navigate('CourseLearning', { course });
          },
        },
      ]
    );
  };

  const handleViewCertificate = (course) => {
    Alert.alert(
      'Certificate',
      `View certificate for "${course.title}"?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'View Certificate',
          onPress: () => {
            Alert.alert('Certificate', 'Certificate viewer will be implemented soon!');
          },
        },
      ]
    );
  };

  const handleRateCourse = (course) => {
    Alert.alert(
      'Rate Course',
      `Rate "${course.title}" and provide feedback?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Rate Course',
          onPress: () => {
            Alert.alert('Rating', 'Course rating system will be implemented soon!');
          },
        },
      ]
    );
  };

  const renderInProgressCourse = ({ item }) => {
    const courseColor = getColorForCourse(item.category);
    
    return (
      <View style={styles.courseCard}>
        <View style={styles.courseHeader}>
          <View style={[styles.courseIcon, { backgroundColor: courseColor }]}>
            <MaterialCommunityIcons 
              name={item.category.includes('Civil') ? 'bridge' :
                    item.category.includes('Software') ? 'laptop' :
                    item.category.includes('Mechanical') ? 'engine' :
                    item.category.includes('Electrical') ? 'lightning-bolt' : 'book-open-variant'} 
              size={24} 
              color="#ffffff" 
            />
          </View>
          <View style={styles.courseInfo}>
            <Text style={styles.courseTitle}>{item.title}</Text>
            <Text style={styles.courseSubtitle}>{item.subtitle}</Text>
            <Text style={styles.courseInstructor}>by {item.instructor}</Text>
          </View>
          <View style={styles.courseProgress}>
            <Text style={[styles.progressPercentage, { color: courseColor }]}>{item.progress}%</Text>
          </View>
        </View>

        <View style={styles.progressSection}>
          <View style={styles.progressBar}>
            <View 
              style={[
                styles.progressFill, 
                { width: `${item.progress}%`, backgroundColor: courseColor }
              ]} 
            />
          </View>
          <Text style={styles.progressText}>
            {item.completedLessons} of {item.totalLessons} lessons completed
          </Text>
        </View>

        <View style={styles.courseDetails}>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="play-circle-outline" size={16} color="#6b7280" />
            <Text style={styles.detailText}>Next: {item.nextLesson}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="clock-outline" size={16} color="#6b7280" />
            <Text style={styles.detailText}>{item.estimatedTime}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="history" size={16} color="#6b7280" />
            <Text style={styles.detailText}>Last accessed {item.lastAccessed}</Text>
          </View>
        </View>

        <View style={styles.courseActions}>
          <View style={styles.ratingContainer}>
            <View style={styles.starsContainer}>
              {renderStars(item.rating)}
            </View>
            <Text style={styles.ratingText}>{item.rating}</Text>
          </View>
          <TouchableOpacity
            style={[styles.continueButton, { backgroundColor: courseColor }]}
            onPress={() => handleContinueLearning(item)}
          >
            <MaterialCommunityIcons name="play" size={16} color="#ffffff" />
            <Text style={styles.continueButtonText}>Continue</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  const renderCompletedCourse = ({ item }) => {
    const courseColor = getColorForCourse(item.category);
    
    return (
      <View style={styles.courseCard}>
        <View style={styles.courseHeader}>
          <View style={[styles.courseIcon, { backgroundColor: courseColor }]}>
            <MaterialCommunityIcons name="check-circle" size={24} color="#ffffff" />
          </View>
          <View style={styles.courseInfo}>
            <Text style={styles.courseTitle}>{item.title}</Text>
            <Text style={styles.courseSubtitle}>{item.subtitle}</Text>
            <Text style={styles.courseInstructor}>by {item.instructor}</Text>
          </View>
          <View style={styles.gradeContainer}>
            <Text style={[styles.gradeText, { color: courseColor }]}>{item.grade}</Text>
          </View>
        </View>

        <View style={styles.completionDetails}>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="calendar-check" size={16} color="#6b7280" />
            <Text style={styles.detailText}>Completed: {item.completedDate}</Text>
          </View>
          <View style={styles.detailItem}>
            <MaterialCommunityIcons name="clock-outline" size={16} color="#6b7280" />
            <Text style={styles.detailText}>Duration: {item.duration}</Text>
          </View>
          {item.certificate && (
            <View style={styles.detailItem}>
              <MaterialCommunityIcons name="certificate" size={16} color={courseColor} />
              <Text style={[styles.detailText, { color: courseColor }]}>Certificate earned</Text>
            </View>
          )}
        </View>

        <View style={styles.skillsContainer}>
          <Text style={styles.skillsTitle}>Skills gained:</Text>
          <View style={styles.skillsGrid}>
            {item.skills.map((skill, index) => (
              <View key={index} style={[styles.skillTag, { borderColor: courseColor }]}>
                <Text style={[styles.skillText, { color: courseColor }]}>{skill}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={styles.courseActions}>
          <View style={styles.ratingContainer}>
            <View style={styles.starsContainer}>
              {renderStars(item.rating)}
            </View>
            <Text style={styles.ratingText}>{item.rating}</Text>
          </View>
          <View style={styles.actionButtons}>
            {item.certificate && (
              <TouchableOpacity
                style={[styles.certificateButton, { borderColor: courseColor }]}
                onPress={() => handleViewCertificate(item)}
              >
                <MaterialCommunityIcons name="certificate" size={14} color={courseColor} />
                <Text style={[styles.certificateButtonText, { color: courseColor }]}>Certificate</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity
              style={[styles.rateButton, { backgroundColor: courseColor }]}
              onPress={() => handleRateCourse(item)}
            >
              <MaterialCommunityIcons name="star" size={14} color="#ffffff" />
              <Text style={styles.rateButtonText}>Rate</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  };

  const renderSectionHeader = ({ section }) => (
    <View style={styles.sectionHeader}>
      <Text style={styles.sectionTitle}>{section.title}</Text>
      <Text style={styles.sectionCount}>{section.data.length} courses</Text>
    </View>
  );

  const renderHeader = () => (
    <View>
      {/* Learning Summary */}
      <View style={styles.summaryCard}>
        <Text style={styles.welcomeText}>Hello, {getUserName()}!</Text>
        <Text style={styles.summaryTitle}>Your Learning Journey</Text>
        
        <View style={styles.statsGrid}>
          <View style={styles.statItem}>
            <Text style={[styles.statNumber, { color: '#f59e0b' }]}>{learningStats.inProgress}</Text>
            <Text style={styles.statLabel}>In Progress</Text>
          </View>
          <View style={styles.statItem}>
            <Text style={[styles.statNumber, { color: '#10b981' }]}>{learningStats.completed}</Text>
            <Text style={styles.statLabel}>Completed</Text>
          </View>
          <View style={styles.statItem}>
            <Text style={[styles.statNumber, { color: '#3b82f6' }]}>{learningStats.totalHours}</Text>
            <Text style={styles.statLabel}>Total Hours</Text>
          </View>
          <View style={styles.statItem}>
            <Text style={[styles.statNumber, { color: '#8b5cf6' }]}>{learningStats.averageProgress}%</Text>
            <Text style={styles.statLabel}>Avg Progress</Text>
          </View>
        </View>
      </View>

      {/* Tabs */}
      <View style={styles.tabsContainer}>
        <TouchableOpacity
          style={[
            styles.tab,
            activeTab === 'inProgress' && styles.activeTab,
          ]}
          onPress={() => setActiveTab('inProgress')}
        >
          <MaterialCommunityIcons 
            name="play-circle" 
            size={20} 
            color={activeTab === 'inProgress' ? '#f59e0b' : '#6b7280'} 
          />
          <Text
            style={[
              styles.tabText,
              activeTab === 'inProgress' && styles.activeTabText,
            ]}
          >
            In Progress ({learningStats.inProgress})
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity
          style={[
            styles.tab,
            activeTab === 'completed' && styles.activeTab,
          ]}
          onPress={() => setActiveTab('completed')}
        >
          <MaterialCommunityIcons 
            name="check-circle" 
            size={20} 
            color={activeTab === 'completed' ? '#f59e0b' : '#6b7280'} 
          />
          <Text
            style={[
              styles.tabText,
              activeTab === 'completed' && styles.activeTabText,
            ]}
          >
            Completed ({learningStats.completed})
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );

  const sections = [
    {
      title: activeTab === 'inProgress' ? 'Courses in Progress' : 'Completed Courses',
      data: activeTab === 'inProgress' ? inProgressCourses : completedCourses,
    },
  ];

  return (
    <SafeAreaView style={styles.safeArea}>
      <StatusBar barStyle="dark-content" backgroundColor="#f9fafb" />
      
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={styles.backButton}
        >
          <Ionicons name="arrow-back" size={24} color="#f59e0b" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Learning History</Text>
        <TouchableOpacity style={styles.menuButton}>
          <MaterialCommunityIcons name="dots-vertical" size={24} color="#6b7280" />
        </TouchableOpacity>
      </View>

      {/* Using SectionList instead of ScrollView with FlatList to avoid nesting */}
      <SectionList
        sections={sections}
        keyExtractor={(item) => item.id}
        renderItem={activeTab === 'inProgress' ? renderInProgressCourse : renderCompletedCourse}
        renderSectionHeader={renderSectionHeader}
        ListHeaderComponent={renderHeader}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.container}
        stickySectionHeadersEnabled={false}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#f9fafb',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 15,
    paddingVertical: 12,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  backButton: {
    padding: 5,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#f59e0b',
  },
  menuButton: {
    padding: 5,
  },
  container: {
    padding: 15,
  },
  summaryCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  welcomeText: {
    fontSize: 16,
    color: '#6b7280',
    marginBottom: 4,
  },
  summaryTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 20,
  },
  statsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  statItem: {
    alignItems: 'center',
    flex: 1,
  },
  statNumber: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#6b7280',
    textAlign: 'center',
  },
  tabsContainer: {
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 4,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  activeTab: {
    backgroundColor: '#fef3e2',
  },
  tabText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#6b7280',
    marginLeft: 6,
  },
  activeTabText: {
    color: '#f59e0b',
    fontWeight: '600',
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#111827',
  },
  sectionCount: {
    fontSize: 14,
    color: '#6b7280',
  },
  courseCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 3,
  },
  courseHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  courseIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  courseInfo: {
    flex: 1,
  },
  courseTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 2,
  },
  courseSubtitle: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 2,
  },
  courseInstructor: {
    fontSize: 12,
    color: '#9ca3af',
  },
  courseProgress: {
    alignItems: 'center',
  },
  progressPercentage: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  gradeContainer: {
    alignItems: 'center',
  },
  gradeText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  progressSection: {
    marginBottom: 12,
  },
  progressBar: {
    height: 6,
    backgroundColor: '#f3f4f6',
    borderRadius: 3,
    marginBottom: 4,
  },
  progressFill: {
    height: '100%',
    borderRadius: 3,
  },
  progressText: {
    fontSize: 12,
    color: '#6b7280',
  },
  courseDetails: {
    marginBottom: 12,
  },
  completionDetails: {
    marginBottom: 12,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  detailText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 6,
  },
  skillsContainer: {
    marginBottom: 12,
  },
  skillsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 8,
  },
  skillsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  skillTag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    borderWidth: 1,
    marginRight: 6,
    marginBottom: 4,
  },
  skillText: {
    fontSize: 10,
    fontWeight: '500',
  },
  courseActions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  ratingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  starsContainer: {
    flexDirection: 'row',
    marginRight: 6,
  },
  ratingText: {
    fontSize: 12,
    color: '#6b7280',
    fontWeight: '500',
  },
  continueButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  continueButtonText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#ffffff',
    marginLeft: 4,
  },
  actionButtons: {
    flexDirection: 'row',
  },
  certificateButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    borderWidth: 1,
    marginRight: 8,
  },
  certificateButtonText: {
    fontSize: 12,
    fontWeight: '500',
    marginLeft: 4,
  },
  rateButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  rateButtonText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#ffffff',
    marginLeft: 4,
  },
});

export default MyLearningHistoryScreen;
